// Phase 25 iter-6 — billing client (Stripe SaaS).
//
// Backend (backend/src/routes/v1/billing.ts):
//   GET  /billing/subscription      → SubscriptionResponse
//   POST /billing/checkout-session  → { url } (Stripe Checkout)
//   POST /billing/portal-session    → { url } (Stripe Customer Portal)

import {
  API_VERSION_PREFIX,
  type BillablePlan,
  type StripeRedirectResponse,
  type SubscriptionResponse,
} from '@leyrochain/shared';

import { apiClient } from './client';

export async function getSubscription(): Promise<SubscriptionResponse> {
  const { data } = await apiClient.get<SubscriptionResponse>(
    `${API_VERSION_PREFIX}/billing/subscription`,
  );
  return data;
}

export async function startCheckoutSession(plan: BillablePlan): Promise<StripeRedirectResponse> {
  const { data } = await apiClient.post<StripeRedirectResponse>(
    `${API_VERSION_PREFIX}/billing/checkout-session`,
    { plan },
  );
  return data;
}

export async function openCustomerPortal(): Promise<StripeRedirectResponse> {
  const { data } = await apiClient.post<StripeRedirectResponse>(
    `${API_VERSION_PREFIX}/billing/portal-session`,
  );
  return data;
}
